import React from 'react';
import useAuthForm from '../../../../hooks/useAuthForm';
import { contactUs } from '../../../../services/authService';
import validateByType from '../../../../hooks/useFormValidation';

const useContactUs = () => {
  const formInstance = useAuthForm({
    initialValues: {
      name: '',
      email: '',
      subject: '',
      message: '',
    },
    validateFn: (form) => validateByType('contactUs', form),
    submitFn: contactUs,
    formName: 'ContactUsForm'
  });

  return {
    ...formInstance,
  };
};

export default useContactUs;
